import React from 'react'
import { Modal, Button } from 'elements'

export default function StandardModalFooter({ onClose, onContinue, working }) {
  return (
    <Modal.Footer display="flex" alignItems="center">
      <Button mr="medium" kind="secondary" onPress={onContinue} disabled={working}>
        {working ? 'Continuing...' : 'Continue'}
      </Button>
      <Button onPress={onClose} mr="xxxlarge">
        Cancel
      </Button>
    </Modal.Footer>
  )
}
